export default class Pick {
  constructor(category, name){
    this.category = category;
    this.name = name;
  }
}
